import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';


class Landing extends Component {
  render() {
    return(
      <div style={{width: '100%', margin: 'auto'}}>
        <Grid className="landing-grid">
          <Cell col={12}>
            <img className="startImage"
              src="https://github.com/thewildling/Website_photos/blob/main/Images/portrett-sirkel.png?raw=true"
              alt="avatar"
              className="avatar-img"
              />

            <div className="banner-text">
              <h1>Marianne Pettersen</h1>
              <h2>M.Sc Engineering and ICT</h2>
            <hr style={{borderTop: '3px solid #116466 '}} />

          <p> Welcome to my portfolio website. I am a developer with a master of science degree in Engineering and ICT.
          Navigate my website to learn more about me and my projects. NB: The mobile version will arrive soon.</p>

        <div className="social-links">

          {/* LinkedIn */}
          <a href="https://www.linkedin.com/in/mpett/" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-linkedin-square" aria-hidden="true" />
          </a>

          {/* Github */}
          <a href="https://github.com/thewildling" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-github-square" aria-hidden="true" />
          </a>

          {/* NTNU */}
          <a href="https://www.ntnu.edu/studies/mting/" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-mortar-board" aria-hidden="true" />
          </a>

          {/* Game
          <a href="http://operatorgame.epizy.com/" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-gamepad" aria-hidden="true" />
          </a>*/}


        </div>
            </div>
          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/landingpage.js